import { COUNTRY_ACTION_TYPE } from "./country.action";

export const COUNTRY_MESSAGE_CONTEXT = {
	getAll: COUNTRY_ACTION_TYPE.getAll,
};
